/**
 * Modal ecap.
 */
(function ($, window, document) {
  var hasModalPopped = false;
  var lastScrollTop = 0;
  var delta = 300;

  /**
   * Delay function execution as long as it is continued to be invoked.
   *
   * @param function func Function to delay
   * @param int wait Millisecond delay
   * @param bool immediate
   *
   * @see https://davidwalsh.name/essential-javascript-functions
   *
   * @return function
   */
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  /**
   * Bind an event handler to the "scroll" JavaScript event,
   * and detect whether or not the modal ecap should be shown.
   *
   * @return void
   */
  function initializeModalEcap() {
    $(window).scroll(
      debounce(function () {
        var nowScrollTop = $(this).scrollTop();

        if (
          !hasModalPopped &&
          Math.abs(lastScrollTop - nowScrollTop) >= delta
        ) {
          if (nowScrollTop > lastScrollTop) {
            $("#ecapModal").foundation(("reveal", "open"));
            hasModalPopped = true;
          }

          lastScrollTop = nowScrollTop;
        }
      }, 250),
    );
  }

  function isWrapperPresent() {
    return $("#ecapModal").length;
  }

  $(document).ready(function ($) {
    if (isWrapperPresent()) {
      initializeModalEcap();
    }
  });
})(jQuery, window, document);
